// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
	general: {
		scrollImages: boostPFSConfig.custom.scrollImages,
		limit: boostPFSConfig.custom.products_per_page,
		loadProductFirst: false,
		numberFilterTree: 2,
		filterTreeMobileStyle: 'style2'
	},
};

(function () {
	var onSale = false,
		soldOut = false,
		priceVaries = false,
		images = [],
		iteration = 1,
		promoCardsCopied = false,
		boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];


	BoostPFS.inject(this);

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function (e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}

	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data) {
		if (!data) data = this.data;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';

		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

		itemHtml = itemHtml.replace(/{{flexOrder}}/g, iteration);

		// Add Card product class
		itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass());
		// Add sold out Label
		// itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
		// Add sale Label
		// itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
		// Add Price
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
		// Add Badges
		itemHtml = itemHtml.replace(/{{badges}}/g, buildBadgesLabels(data));

		// itemHtml = itemHtml.replace(/{{wishListBtn}}/g , buildWishListBtn(data));

		// Add Review
		if (typeof Integration === 'undefined' ||
			(typeof Integration != 'undefined' &&
				typeof Integration.hascompileTemplate == 'function' &&
				!Integration.hascompileTemplate('reviews'))) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
		}

		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		
    if(current.shop.domain.indexOf('fxd-australia') > -1 ) {
      const longTitle = data.metafields?.[0]?.value.replace(/<BR>/g," - ").split('-')[0]
      const auColour = data.options_with_values?.[0]?.values?.[0]?.title;
      itemHtml = itemHtml.replace(/{{itemTitle}}/g, `<span class="fxd-au-product-title">${data.title.replace("◆", `<span class='diamond'>◆</span>`)}</span>${longTitle ? `<span class="fxd-au-product-subtitle">${longTitle}</span>` : ''}${auColour ? `<span class="fxd-au-product-colour">COLOUR: ${auColour}</span>` : ''}`);
    } else if(current.shop.domain.indexOf('fxd') > -1 ) {
		console.log("here boost data", data)


      const longTitle = data.metafields?.[0]?.value.replace(/<BR>/g," - ").split('-')[0]
	  itemHtml = itemHtml.replace(/{{itemTitle}}/g, `<span class="fxd-product-title">${data.title.replace("◆", `<span class='diamond'>◆</span>`)}</span> - ${longTitle ? `${longTitle} - ` : ''} <span class="uppercase">${data.options_with_values?.[0]?.values?.[0]?.title}</span>`);
      // itemHtml = itemHtml.replace(/{{itemTitle}}/g, `${data.title} - <span class="uppercase">${data.metafields?.[0]?.value.toLowerCase().replace(/<br>/g,"")}</span>`);
    } else if(current.shop.domain.indexOf('sdouble') > -1){
		const customTitle = data.metafields?.find(mf => mf.namespace === 'custom' && mf.key === 'product_ecomm_title')?.value || ''
		const customCategory = data.metafields?.find(mf => mf.namespace === 'custom' && mf.key === 'product_ecomm_category')?.value || ''
		const longTitle = data.metafields?.[0]?.value
		.replace(/<BR>/g, " - ")
		.replace(/\["/g, "")
		.replace(/"\]/g, "")
		.split('-')[0];
		const finalTitle = customTitle ? `
		<span class="fxd-product-title">
			<span class="product__title" {{ block.shopify_attributes }}>
				${customTitle}
			</span>
			<span class="product__category">${customCategory}</span>
		</span>
		<span class="uppercase"><BR> COLOUR /  ${data.options_with_values?.[0]?.values?.[0]?.title}</span>
		` : `<span class="fxd-product-title">${data.title.replace("◆", `<span class='diamond'>◆</span>`)}</span>  ${longTitle ? ` - ${longTitle} ` : ''}  <span class="uppercase"><BR> COLOUR /  ${data.options_with_values?.[0]?.values?.[0]?.title}</span>`;
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, finalTitle);
			
	}else {
      itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    }
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, "/products/"+data.handle);
    	itemHtml = itemHtml.replace(/{{itemDescription}}/g, data.description ? data.description : '');

		iteration++;

		return itemHtml;
	};

	function buildWishListBtn(data) {
    const firstAvailableVariant = data.variants.find(v => v.available);
    return `<button 
      data-with-epi="true" 
      class="swym-button swym-add-to-wishlist-view-product product_${data.id}" 
      data-swaction="addToWishlist"
      data-product-id="${data.id}" 
      data-variant-id="${firstAvailableVariant ? firstAvailableVariant.id : data.id}"
      data-product-url="${current.shop.domain}/products/${data.handle}" 
      aria-label="Add to Wishlist">
        <span class="wishlist-add"> ${window.wishlist.icon} </span>
        <span class="wishlist-added"> ${window.wishlist.icon_added} </span>
    </button>`
	}

	function buildBadgesLabels(data) {
    return `
      <grid-badges 
        data-compare-at-price="${data.compare_at_price}" 
        data-price="${data.price}"
        data-available="${data.available}"
        data-tags="${data.tags.join(",")}"
      /></grid-badges>`
	}

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	function buildImages(data) {
		var html = '',
			aspectRatio = '',
			rangeWidths = boostPFSRangeWidths,
			paddingBottom = 100;

		var dataSrcSet = '',
			imgAlt = data.title,
			flipImageSrcSet = '';

		var activeSwapImage = !Utils.isMobile() && images.length > 1 &&
			boostPFSThemeConfig.custom.hasOwnProperty('show_secondary_image') &&
			boostPFSThemeConfig.custom.show_secondary_image == true;

		for (var i = 0; i < rangeWidths.length; i++) {
			dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';

			if (activeSwapImage) {
				flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
			}

			if (i < rangeWidths.length - 1) {
				dataSrcSet += ', ';

				if (activeSwapImage) {
					flipImageSrcSet += ', ';
				}
			}
		}

		if (boostPFSFilterConfig.general.scrollImages == true) {
			let imageHtml = ``;
			imageHtml += `
			<span class="sr-only">Carousel</span>
			`
			for (let index = 0; index < images.length; index++) {
				let image = images[index];
				let imageSrcSet = '';
				for (var i = 0; i < rangeWidths.length; i++) {
					imageSrcSet += Utils.optimizeImage(image['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
				}
				imageHtml += `
				<li class="grid__item slider__slide full__width max__width" data-slide="${index}" role="group" aria-label="slide ${index+1} of ${images.length}">
					<img 
					class="full__width"
					loading="lazy"
					src="${Utils.optimizeImage(image.src, '533x')}"
					alt="${imgAlt}"
					srcset="${imageSrcSet}"
					sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"
					>
              	</li>`
			}

			return `
			<!-- generated by javascript -->
			<section aria-label="carousel">
			<slider-component class="slider-mobile-gutter slider-collection">
				<ul class="slider slider--desktop slider--tablet grid grid--1-col">
					${imageHtml}
				</ul>
				<div class="desktop-buttons slider-buttons no-js-hidden">
					<span class="sr-only">Buttons to change image</span>
					<section role="carousel" style="display: flex;">
						<button type="button" class="slider-button slider-button--prev" name="previous" aria-label="Slide left" disabled="true">
							<svg alt="image backwards" aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
							</svg>
						</button>
						<div class="slider-counter caption">
							<span class="slider-counter--current">1</span>
							<span aria-hidden="true"> / </span>
							<span class="visually-hidden">of</span>
							<span class="slider-counter--total">${images.length}</span>
						</div>
						<button type="button" class="slider-button slider-button--next" name="next" aria-label="Slide right">
							<svg alt="image forward" aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
							</svg>
						</button>
					</section>
				</div>
			</slider-component>
			</section>
			<!-- end generated by javascript -->
			`;

		} else {
			if (images.length > 0) {
				aspectRatio = images[0]['width'] / images[0]['height'];
				paddingBottom = 1 / aspectRatio * 100;

				html += '<div';
				if (boostPFSThemeConfig.custom.hasOwnProperty('add_image_padding') &&
					boostPFSThemeConfig.custom.add_image_padding === true) {
					html += ' class="card__media-full-spacer"';
				}
				html += '>';
				html += '<div class="media media--transparent media--';
				if (boostPFSThemeConfig.custom.hasOwnProperty('media_size')) {
					html += boostPFSThemeConfig.custom.media_size;
				}
				html += ' media--hover-effect"';
				if (boostPFSThemeConfig.custom.hasOwnProperty('media_size') &&
					boostPFSThemeConfig.custom.media_size == 'adapt' &&
					images.length > 0) {
					html += ' style="padding-bottom: ' + paddingBottom + '%"';
				}
				html += '>'
				html += '<img class="motion-reduce"' +
					'loading="lazy"' +
					'srcset="' + dataSrcSet + '" ' +
					'height="' + images[0].height + '" ' +
					'width="' + images[0].width + '" ' +
					'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
					'src="' + Utils.optimizeImage(images[0].src, '533x') + '" ' +
					'alt="' + imgAlt + '" />';
				
					html += '<img class="motion-reduce"' +
					'loading="lazy"' +
					'srcset="' + dataSrcSet + '" ' +
					'height="' + images[0].height + '" ' +
					'width="' + images[0].width + '" ' +
					'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
					'src="' + Utils.optimizeImage(images[0].src, '533x') + '" ' +
					'alt="' + imgAlt + '" />';

					html += '<img class="motion-reduce"' +
					'loading="lazy"' +
					'srcset="' + dataSrcSet + '" ' +
					'height="' + images[0].height + '" ' +
					'width="' + images[0].width + '" ' +
					'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
					'src="' + Utils.optimizeImage(images[0].src, '533x') + '" ' +
					'alt="' + imgAlt + '" />';

				if (activeSwapImage) {
					html += '<img class="motion-reduce"' +
					'loading="lazy"' +
					'srcset="' + flipImageSrcSet + '" ' +
					'height="' + images[1].height + '" ' +
					'width="' + images[1].width + '" ' +
					'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
					'src="' + Utils.optimizeImage(images[1].src, '533x') + '" ' +
					'alt="' + imgAlt + '" />';
				}
				html += '</div>';
				html += '</div>';
			} else {
				html += '<div class="card__content"><h2 class="card__text h2">' + data.title  + '</h2></div>'
			}
		}
		return html;
	}

	function buildCardProductClass() {
		var html = '';
		if (!images || (images && images.length === 0)) {
			html = 'card--text-only card--soft';
		} else {
      html = 'card--outline';
    }
		return html;
	}

	function buildVendor(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
			boostPFSThemeConfig.custom.show_vendor === true) {
			html = boostPFSTemplate.vendorHtml;
		}
		return html;
	}

	function buildPrice(data) {
		var html = '';
		var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
		var moneyPrice = priceVaries ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, Utils.formatMoney(data.price_min))
			: Utils.formatMoney(data.price_min);
		var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : ''
		html = `<div class="price ${soldOut ? 'price--sold-out' : ''} ${onSale ? 'price--on-sale' : ''}${noComparePrice ? 'price--no-compare' : ''}"
					<div>
						<div class="price__regular">
							<div>
								<span class="visually-hidden visually-hidden--inline">
									${boostPFSConfig.label.regular_price}
								</span>
							</div>
							<div>
								<span class="price-item price-item--regular p">
									${moneyPrice}
						  		</span>
							</div>
						</div>
						<div class="price__sale">
							<div class="price__compare">
								<span class="visually-hidden visually-hidden--inline p">
									${Utils.formatMoney(data.sale_price)}
								</span>
							</div>
							<div class="price__compare">
								<s class="price-item price-item--regular p">
								${Utils.formatMoney(data.compare_at_price_min)}
								</s>
						  	</dd>
							<div>
							  <span class="visually-hidden visually-hidden--inline">${boostPFSConfig.label.sale_price}</span>
							</div>
							<div class="price__last">
								<span class="price-item price-item--sale p">
									${moneyPrice}
								</span>
						  	</div>
						</div>
						<small class="unit-price caption ${unitPriceClass}">
							<div class="visually-hidden">${boostPFSConfig.label.unit_price}</div>
							<div class="price__last">
								<span>${Utils.formatMoney(data.selected_or_first_available_variant && data.selected_or_first_available_variant.unit_price)}</span>
								<span aria-hidden="true">/</span>
								<span class="visually-hidden">&nbsp;${boostPFSConfig.label.unit_price_separator}&nbsp;</span>
							</dd>
					  </small>
					</dl>
				</div>`
		return html;
	}

	function buildSoldOutLabel() {
		// Build Sold out label
		var soldOutLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut) {
			soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{soldOutBadgeClass}}/g, boostPFSThemeConfig.custom.sold_out_badge_color_scheme);
		}
		return soldOutLabel;
	}

	function buildSaleLabel() {
		// Build Sale label
		var saleLabel = '';
		if (onSale && !soldOut) {
			saleLabel = `<div class="card__badge"><span class="badge badge--top-left color-accent-2">Sale</span></div>`
		}
		return saleLabel;
	}

	function buildReview(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
			boostPFSThemeConfig.custom.show_product_review == true && Utils.getProductMetafield(data, 'reviews', 'rating') !== null) {
			var ratingObj = JSON.parse(Utils.getProductMetafield(data, 'reviews', 'rating'));
      var rating_decimal = 0;
      var decimal = parseFloat(ratingObj.value.rating);
      if (decimal >=0.3 && decimal <= 0.7) {
        rating_decimal = 0.5;
      } else if (decimal > 0.7) {
        rating_decimal = 1;
      }
      html = `<div class="rating" role="img" aria-label="${boostPFSConfig.label.star_reviews_info.replace('{{ rating_value }}', ratingObj.value).replace('{{ rating_max }}', ratingObj.value.scale_max)}">
                <span aria-hidden="true" class="rating-star color-icon-${boostPFSConfig.custom.accent_icons}" style="--rating: ${Math.round(ratingObj.value.rating)}; --rating-max: ${ratingObj.value.scale_max}; --rating-decimal: ${rating_decimal};"></span>
              </div>
              <p class="rating-text caption">
                <span aria-hidden="true">${ratingObj.value} / ${ratingObj.value.scale_max}</span>
              </p>
              <p class="rating-count caption">
                <span aria-hidden="true">(${Utils.getProductMetafield(data, 'reviews', 'rating_count')})</span>
                <span class="visually-hidden">${Utils.getProductMetafield(data, 'reviews', 'rating_count')} ${boostPFSConfig.label.total_reviews}</span>
              </p>`;
		}
		return html;
	}

	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					var isSelected = ''
					if(paramSort == k) {
						isSelected = 'selected="selected"'
					}
					sortingItemsHtml += '<option value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	ProductSorting.prototype.render = function () {
		jQ(Selector.topSorting).html(this.compileTemplate());

		if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
			jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
		}

		var labelSort = '';
		var paramSort = Globals.queryParams.sort || '';
		var sortingList = Utils.getSortingList();
		if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
			labelSort = sortingList[paramSort];
		} else {
			labelSort = Labels.sorting_heading;
		}

		jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
	}

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function() {
		jQ('.collection-filters__sort').change(function(e) {
			e.preventDefault();
			FilterApi.setParam('sort', jQ(this).val());
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});
      
        jQ(Selector.topSorting + " select").change(function(e) {
          e.preventDefault();
          FilterApi.setParam('sort', jQ(this).val());
          FilterApi.setParam('page', 1);
          FilterApi.applyFilter('sort');
        });
	};

	function copyPromotionCards() {
		if (promoCardsCopied == true) {
			return;
		}
		let collectionContainer = document.getElementById('main-collection-product-grid');
		let promoCardsContainer = document.getElementById('promotionCards');
		if (!promoCardsContainer) {
			return;
		}
		let promoCards = promoCardsContainer.children

		for (let i = 0; i < promoCards.length; i++) {
			let promoCard = promoCards[i].cloneNode(true);
			collectionContainer.append(promoCard);
		}
		promoCardsCopied = true;
	}

	function addPaginatedLinks(totalProduct) {
		var totalPage = Math.ceil(totalProduct / boostPFSFilterConfig.general.limit);
		if (totalPage <= 1) {
			return;
		}

		let pageslinksHtml = ``;
		for (var i = 1; i <= totalPage; i++) {
			pageslinksHtml += `<a href="${Utils.buildToolbarLink('page', 1, i)}"></a>`;
		}
    const el = document.getElementById('boost-pfs-filter-direct-page-links');
    if(el) el.innerHTML = pageslinksHtml
 	}

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function(data, eventType) {
    console.log('after render', this.data, eventType);
		if (!data) data = this.data;
		copyPromotionCards();
		addPaginatedLinks(this.totalProduct);
   try {
      if("_swat" in window)  _swat.initializeActionButtons("#main-collection-product-grid")
	} catch (error) {
  console.warn (error)
   }
    }
  
	// Build Additional Elements
	Filter.prototype.afterRender = function(data, eventType) {
		if(this.data.event_type == 'page') {
			if(this.data.products.length) {
				console.log('added focus to', `[data-id="${this.data.products[0].id}"]`)
				$(`[data-id="${this.data.products[0].id}"] .card--product`).focus()
			}
		}

		var elements = document.querySelectorAll('.card-information__text');
        elements.forEach(function(element) {
            var html = element.innerHTML;
            if (html.indexOf('◆') > -1) {
              element.innerHTML = html.replace('◆', '<span class="diamond">◆</span>');
            }
        });
    
		if (!data) data = this.data;
		jQ('.boost-pfs-filter-total-product').html(data.total_product + ' products');
	};

	/************************** END BUILD TOOLBAR **************************/
})();